var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "form",
      [
        _c("div", [_vm._v("LOGIN")]),
        _c("gl-input", {
          directives: [
            {
              name: "skeletor",
              rawName: "v-skeletor:onChange",
              value: _vm.setValue,
              expression: "setValue",
              arg: "onChange"
            }
          ],
          attrs: {
            id: "login.username",
            type: "email",
            label: "Email",
            placeholder: "Email",
            value: _vm.form.username
          },
          model: {
            value: _vm.form.username,
            callback: function($$v) {
              _vm.$set(
                _vm.form,
                "username",
                typeof $$v === "string" ? $$v.trim() : $$v
              )
            },
            expression: "form.username"
          }
        }),
        _c("gl-input", {
          directives: [
            {
              name: "skeletor",
              rawName: "v-skeletor:onChange",
              value: _vm.setValue,
              expression: "setValue",
              arg: "onChange"
            }
          ],
          attrs: {
            id: "login.password",
            type: "password",
            label: "Password",
            placeholder: "Password",
            value: _vm.form.password
          },
          model: {
            value: _vm.form.password,
            callback: function($$v) {
              _vm.$set(
                _vm.form,
                "password",
                typeof $$v === "string" ? $$v.trim() : $$v
              )
            },
            expression: "form.password"
          }
        }),
        _c("gl-button", {
          attrs: {
            id: "login.btn-login",
            "color-primary": "",
            type: "submit",
            text: "Login",
            disabled: !_vm.dirtyFields
          },
          on: {
            onClick: function($event) {
              $event.preventDefault()
              return _vm.login.apply(null, arguments)
            }
          }
        }),
        _vm.form.error ? _c("p", [_vm._v(_vm._s(_vm.form.error))]) : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }